import React, { useEffect, useRef } from 'react';
import jsPDF from 'jspdf';
import QRCode from 'qrcode';
import { _single } from '../../../core/services/dataBean/EntityCatalog';
import defaultPhoto from '../../../assets/img/dphoto.jpg';

interface CarnetProps {
  nombre: string;
  apellido: string;
  grupo: string;
  identificacion: string;
  rh: string;
  fotoUrl: string;
  Entity?: string;
  Eps?: string;
  Arl?: string;
  backgroundUrl?: string;
  gradientStart?: string;
  gradientEnd?: string;
}

const CarnetVertical: React.FC<CarnetProps> = ({
  nombre,
  apellido,
  grupo,
  identificacion,
  rh,
  fotoUrl,
  Entity,
  Eps,
  Arl,
  backgroundUrl,
  gradientEnd,
  gradientStart
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  const qrTemplate =
    `CARNÉ DE IDENTIFICACIÓN
Identificación: ${identificacion}  
Nombre: ${nombre} ${apellido}
Cargo: ${rh ?? ''}  
Área: ${grupo ?? ''}  
Eps: ${Eps ?? '---'}  
Arl: ${Arl ?? '---'}  
Empresa: ${Entity}
Impresión: ${_single.getCurrenDate()}
`;

  useEffect(() => {
    generarCarnet();
  }, [backgroundUrl]);

  const generarCarnet = async () => {
    _single.spinner(true);
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const scale = 4;
    const width = 240;
    const height = 380;

    canvas.width = width * scale;
    canvas.height = height * scale;
    ctx.scale(scale, scale);

    if (backgroundUrl) {
      const fondo = new Image();
      fondo.src = backgroundUrl;
      fondo.crossOrigin = 'anonymous';
      fondo.onload = () => {
        ctx.globalAlpha = 0.9;
        ctx.drawImage(fondo, 0, 0, width, height);
        ctx.globalAlpha = 1.0;
        dibujarContenido(ctx, width, height);
      };
      fondo.onerror = () => {
        console.warn("Error cargando el fondo, usando degradado.");
        dibujarDegradado(ctx, width, height);
      };
    } else {
      dibujarDegradado(ctx, width, height);
    }
  };

  const dibujarDegradado = (ctx: CanvasRenderingContext2D, width: number, height: number) => {
    const gradient = ctx.createLinearGradient(0, 0, 0, height);
    gradient.addColorStop(0, gradientStart || "#fff");
    gradient.addColorStop(1, gradientEnd || "#fff");

    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, height);

    dibujarContenido(ctx, width, height);
  };


  const drawWrappedText = (
    ctx: CanvasRenderingContext2D,
    text: string,
    x: number,
    y: number,
    maxWidth: number,
    lineHeight: number
  ) => {
    const words = text.split(' ');
    let line = '';
    for (let n = 0; n < words.length; n++) {
      const testLine = line + words[n] + ' ';
      const metrics = ctx.measureText(testLine);
      const testWidth = metrics.width;
      if (testWidth > maxWidth && n > 0) {
        ctx.fillText(line.trim(), x, y);
        line = words[n] + ' ';
        y += lineHeight;
      } else {
        line = testLine;
      }
    }
    ctx.fillText(line.trim(), x, y);
  };

  const dibujarContenido = async (ctx: CanvasRenderingContext2D, width: number, height: number) => {
    const centerX = width / 2;
    const photoSize = 100;
    const qrSize = 80;

    const imagen = new Image();
    imagen.crossOrigin = 'anonymous';
    imagen.src = fotoUrl || defaultPhoto;
    imagen.onerror = () => {
      imagen.onerror = null;
      imagen.src = defaultPhoto;
    };

    imagen.onload = async () => {
      let y = 120;
      ctx.drawImage(imagen, centerX - photoSize / 2, y, photoSize, photoSize);
      y += photoSize + 20;

      ctx.fillStyle = '#000000';
      ctx.textAlign = 'center';
      ctx.font = 'bold 11px Montserrat';
      ctx.fillText(nombre.toUpperCase(), centerX, y);
      y += 12;

      ctx.font = 'bold 11px Montserrat';
      ctx.fillText(apellido.toUpperCase(), centerX, y);
      y += 12;

      ctx.fillText(`C.C. ${identificacion}`, centerX, y);
      y += 20;

      ctx.font = 'normal 10px Montserrat';
      drawWrappedText(ctx, rh, centerX, y, 200, 10);

      ctx.font = 'normal 9px Montserrat';
      ctx.textAlign = 'center';
      drawWrappedText(ctx, grupo, 95, 315, 120, 10);

      const qrCanvas = document.createElement('canvas');
      await QRCode.toCanvas(qrCanvas, qrTemplate, { width: qrSize * 4 });
      ctx.drawImage(qrCanvas, width - qrSize, 300, qrSize, qrSize);

      _single.spinner(false);
    };
  };

  const descargarPDF = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF({
      orientation: 'portrait',
      unit: 'px',
      format: [240, 380],
    });
    pdf.addImage(imgData, 'PNG', 0, 0, 240, 380);
    pdf.save(`${Entity}.pdf`);
  };

  return (
    <div>
      {/* {fotoUrl}  */}
      <canvas ref={canvasRef} style={{ border: '1px solid #e9e9e9', marginTop: '10px', width: '240px', height: 'auto' }} />
      <div className="mt-2">
        <button className='btn btn-primary' onClick={descargarPDF}>Descargar PDF</button>
      </div>
    </div>
  );
};

export default CarnetVertical;
